// Team fouls warning thresholds (002 FR-016, parity with web baseline 001).
//
// Baseline behavior: a warning style shows when fouls > 5 and (fouls % 5 === 4)
// — i.e. at 9, 14, 19, 24, … ; a buzzer sounds at 10 and every 5 thereafter (10, 15, 20, …).

export function foulState(fouls) {
  return {
    warning: fouls > 5 && fouls % 5 === 4,
    buzzer: fouls >= 10 && fouls % 5 === 0,
  };
}
